export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_expenseName') || '费用项目',
    field: 'expenseName',
    align: 'center',
    minWidth: 200,
    slots: { edit: 'expense' },
    editRender: { enabled: true },
  },
  {
    title: that.$l('table_label_financeExpense') || '财务费用',
    field: 'v_expenseType',
    align: 'center',
    minWidth: 200,
  },
  {
    title: that.$l('table_label_chargeQty') || '计费数量',
    field: 'chargeQty',
    align: 'center',
    minWidth: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: '请输入计费数量',
        precision: 0,
        min: 0,
        step: 1,
        'step-strictly': true,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyUnitPrice') || '计费单价',
    field: 'currencyUnitPrice',
    align: 'center',
    minWidth: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: '请输入计费单价',
        precision: 2,
        min: 0,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_currencyTotalAmount') || '计费总价',
    field: 'currencyTotalAmount',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ row }) => {
      const { currencyTotalAmount: value } = row || {}
      return !value ? value : value.toLocaleString()
    },
    isTotalColumn: true,
  },
  {
    title: '说明',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 1000,
        showWordLimit: true,
      },
    },
  },
]
